import {Grid, MenuItem, TextField,} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/styles";
import CustomSnackbar from "../../../user/shared/CustomSnackbar";
import {badEmails, formatAgeRange, fromArrayToOrSentence} from '../../../../helpers/utils';
import useAdminUserSession from "../../../../hooks/useAdminUserSession";
import useYears from "../../../../hooks/useYears";
import moment from "moment/moment";

const useStyles = makeStyles((theme) => ({
  contentSection: {
    padding: '16px 22px',
    background: '#fff',
    marginBottom: '15px',
    borderRadius: '3px',
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionHeaderTitle: {
    fontSize: '17px',
    fontWeight: '600',
    color: '#000',
  },
  contentSectionContent: {

  },
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  form: {
    height: '100%',
  },
  field: {
    '& label.Mui-focused': {
      color: '#000',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#000',
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#000',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#000',
      },
    },
  },
  tabActive: {
    color: '#1E69E5',
  },
  associationLink: {
    position: 'absolute',
    top: '-10px',
    right: '10px',
    cursor: 'pointer',
    decoration: 'none',
    '&:hover': {
      decoration: 'none',
    }
  },
  inputWithAssociationLink: {
    position: 'relative',
  },
  urlContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
}));


const AiDentifiedData = ({
                           aiDentifiedData,
                           handleFieldChange,
                         }) => {
  const {session} = useAdminUserSession();
  const classes = useStyles();
  const canEdit = session.isSuperAdmin || session.inHouseResearch;

  const [personalEmailAddress, setPersonalEmailAddress] = useState(aiDentifiedData.personal_email_address || '')
  const [age, setAge] = useState('')
  const [birthYear, setBirthYear] = useState(aiDentifiedData.primary_birth_year || '')

  const [mobilePhoneNumber, setMobilePhoneNumber] = useState(aiDentifiedData.mobile_phone_number || '')
  const [otherPhoneNumber, setOtherPhoneNumber] = useState(aiDentifiedData.other_phone_number || '')

  const [homeAddress1, setHomeAddress1] = useState(aiDentifiedData.address_1 || '')
  const [homeAddress2, setHomeAddress2] = useState(aiDentifiedData.address_2 || '')
  const [homeCity, setHomeCity] = useState(aiDentifiedData.city || '')
  const [homeState, setHomeState] = useState(aiDentifiedData.state || '')
  const [homeZip, setHomeZip] = useState(aiDentifiedData.zipcode || '')
  const [homeCounty, setHomeCounty] = useState(aiDentifiedData.county || '')
  const [warningMessage, setWarningMessage] = useState('');

  const actualYear = moment().year()
  const years = useYears(false,actualYear - 100, actualYear - 18 );

  // Stay in sync with external clears (e.g. the personal email being redacted after
  // failing validation on the General Contact Info tab) - otherwise this local copy
  // stays stale and re-sends the old value on the next blur, undoing the redaction.
  useEffect(() => {
    setPersonalEmailAddress(aiDentifiedData.personal_email_address || '')
  }, [aiDentifiedData.personal_email_address])

  const setValidPhoneNumber = (setPhoneNumber, event, type) => {
    const value = event.target.value
    const regExp = /^[+\-0-9(). ]+$/gi
    if ( value ==='' || regExp.test(value)) {
      if (!validateUniquePhone(value,type)) {
        setWarningMessage("Phones must differ")
      } else {
        setPhoneNumber(value)
        setWarningMessage('')
      }
    } else {
      setWarningMessage("Invalid Phone number")
    }
  }

  const validateUniquePhone = (value, type) => {
    if (value === '' || value === undefined || value === null ) {
      return true;
    }

    if (type === 'mobilePhoneNumber') {
      if (value === otherPhoneNumber) {
        return false;
      }
    }

    if (type === 'otherPhoneNumber') {
      if (value === mobilePhoneNumber) {
        return false;
      }
    }

    return true;
  }

  const setValidPersonalEmail = (value) => {
    if (badEmails.some(x => value.startsWith(x))) {
      setWarningMessage(`Email is not allowed. It cannot starts with ${fromArrayToOrSentence(badEmails)}`)
    } else {
      setPersonalEmailAddress(value);
      setWarningMessage('')
    }
  }

  const calculateAge = (birthYear) => {
    if (!birthYear) return '';
    const currentYear = new Date().getFullYear();
    const calculatedAge = currentYear - birthYear;
    return formatAgeRange(calculatedAge);
  };

  useEffect(() => {
    if (birthYear) {
      setAge(calculateAge(birthYear));
    }
  }, [birthYear]);

  const handleBirthYearChange = (event) => {
    const selectedYear = event.target.value;
    setBirthYear(selectedYear);

    const calculatedAge = calculateAge(selectedYear);
    setAge(calculatedAge);

    handleFieldChange(event);
  };


  const setField = (setField, event, type) => {
    const value = event.target.value
    setField(value)
  }

  return (
    <div className={classes.contentSection}>
      <div className={classes.contentSectionContent}>
        <div className={classes.formGroup}>
          <Grid container spacing={3} >
            <Grid
                item
                md={4}
                xs={12}
            >
              <TextField
                  fullWidth
                  label="Personal Email Address"
                  name="personal_email_address"
                  onChange={(e) => setValidPersonalEmail(e.target.value)}
                  onBlur={(e) => handleFieldChange(e, personalEmailAddress)}
                  value={personalEmailAddress}
                  variant="outlined"
                  className={classes.field}
                  disabled={!canEdit}
              />
            </Grid>
            <Grid
                item
                md={1}
                xs={12}
            >
              <TextField
                  fullWidth
                  label="Age Range"
                  name="age"
                  value={age}
                  variant="outlined"
                  className={classes.field}
                  disabled={true}
              />
            </Grid>
            <Grid item xs={1}>
              <TextField
                  select
                  fullWidth
                  value={birthYear}
                  name='primary_birth_year'
                  onChange={handleBirthYearChange}
                  label='Birth Year'
                  variant='outlined'
              >
                {years.map((year) => <MenuItem key={`birth_year-${year.id}`} value={year.id}>{year.id}</MenuItem>)}
              </TextField>
            </Grid>
            <Grid
                item
                md={3}
                xs={12}
            >
              <TextField
                  fullWidth
                  label="Mobile Phone Number"
                  name="mobile_phone_number"
                  onChange={(e) => setValidPhoneNumber(setMobilePhoneNumber, e, "mobilePhoneNumber")}
                  onBlur={(e) => handleFieldChange(e, mobilePhoneNumber)}
                  value={mobilePhoneNumber}
                  variant="outlined"
                  className={classes.field}
                  disabled={!canEdit}
              />
            </Grid>
            <Grid
                item
                md={3}
                xs={12}
            >
              <TextField
                  fullWidth
                  label="Other Phone Number"
                  name="other_phone_number"
                  onChange={(e) => setValidPhoneNumber(setOtherPhoneNumber, e, "otherPhoneNumber")}
                  onBlur={(e) => handleFieldChange(e, otherPhoneNumber)}
                  value={otherPhoneNumber}
                  variant="outlined"
                  className={classes.field}
                  disabled={!canEdit}
              />
            </Grid>
            <Grid
                item
                md={2}
                xs={12}
            >
              <TextField
                  fullWidth
                  label="Home State"
                  name="state"
                  onChange={(e) => setField(setHomeState, e, "state")}
                  onBlur={(e) => handleFieldChange(e, homeState)}
                  value={homeState}
                  variant="outlined"
                  className={classes.field}
                  disabled={!canEdit}
              />
            </Grid>
            <Grid
                item
                md={2}
                xs={12}
            >
              <TextField
                  fullWidth
                  label="Home County"
                  name="county"
                  onChange={(e) => setField(setHomeCounty, e, "county")}
                  onBlur={(e) => handleFieldChange(e, homeCounty)}
                  value={homeCounty}
                  variant="outlined"
                  className={classes.field}
                  disabled={!canEdit}
              />
            </Grid>
            <Grid
                item
                md={2}
                xs={12}
            >
              <TextField
                  fullWidth
                  label="Home City"
                  name="city"
                  onChange={(e) => setField(setHomeCity, e, "city")}
                  onBlur={(e) => handleFieldChange(e, homeCity)}
                  value={homeCity}
                  variant="outlined"
                  className={classes.field}
                  disabled={!canEdit}
              />
            </Grid>
            <Grid
                item
                md={3}
                xs={12}
            >
              <TextField
                  fullWidth
                  label="Home Address Line 1"
                  name="address_1"
                  onChange={(e) => setField(setHomeAddress1, e, "address_1")}
                  onBlur={(e) => handleFieldChange(e, homeAddress1)}
                  value={homeAddress1}
                  variant="outlined"
                  className={classes.field}
                  disabled={!canEdit}
              />
            </Grid>
            <Grid
                item
                md={2}
                xs={12}
            >
              <TextField
                  fullWidth
                  label="Home Address Line 2"
                  name="address_2"
                  onChange={(e) => setField(setHomeAddress2, e, "address_2")}
                  onBlur={(e) => handleFieldChange(e, homeAddress2)}
                  value={homeAddress2}
                  variant="outlined"
                  className={classes.field}
                  disabled={!canEdit}
              />
            </Grid>
            <Grid
                item
                md={1}
                xs={12}
            >
              <TextField
                  fullWidth
                  label="Home Zip"
                  name="zipcode"
                  onChange={(e) => setField(setHomeZip, e, "zipcode")}
                  onBlur={(e) => handleFieldChange(e, homeZip)}
                  value={homeZip}
                  variant="outlined"
                  className={classes.field}
                  disabled={!canEdit}
              />
            </Grid>
          </Grid>
        </div>
        {
          warningMessage ? <CustomSnackbar
              open={warningMessage}
              closeHandler={() => {
                setWarningMessage('')
              }}
              message={warningMessage}
              options={{
                severity: 'warning'
              }}
          /> : null
        }
      </div>
    </div>
  )
}

export default AiDentifiedData;